@import "~@govbr-ds/core/src/components/modal/modal";

.br-modal.scrollable {
  max-height: 400px;
}

.br-modal-footer.justify-content-end {
  justify-content: flex-end;
}
